export const categories = [
  { id: 'remen-tuijian', name: '热门推荐', slug: 'remen-tuijian', icon: 'ri-fire-line' },
  { id: 'lianai-manhua', name: '恋爱漫画', slug: 'lianai-manhua', icon: 'ri-heart-line' },
  { id: 'qihuan-manhua', name: '奇幻漫画', slug: 'qihuan-manhua', icon: 'ri-magic-line' },
  { id: 'dongzuo-manhua', name: '动作漫画', slug: 'dongzuo-manhua', icon: 'ri-sword-line' },
  { id: 'xuanyi-manhua', name: '悬疑漫画', slug: 'xuanyi-manhua', icon: 'ri-search-eye-line' },
  { id: 'gaoxiao-manhua', name: '搞笑漫画', slug: 'gaoxiao-manhua', icon: 'ri-emotion-laugh-line' },
  { id: 'dushi-manhua', name: '都市漫画', slug: 'dushi-manhua', icon: 'ri-building-line' },
  { id: 'xiaoyuan-manhua', name: '校园漫画', slug: 'xiaoyuan-manhua', icon: 'ri-school-line' },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);
export const getCategoryNameBySlug = (slug: string) => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};